import React from 'react';
import TextEditor from '../TextEditor';

const Text = (props) => {
    const {
        address,
        className,
        onSaveSettings,
        triggerControlVisibility,
    } = props;

    const handleTextChange = (htmlText) => {
        onSaveSettings({ name: 'content', value: htmlText }, address);
    };

    return (
        <div
            className={`dorik-text ${className}`}
            dangerouslySetInnerHTML={{ __html: props.children }}
        ></div>
    );
    // return (
    //     <TextEditor
    //         html={props.children}
    //         onChange={handleTextChange}
    //         className={`dorik-text ${className}`}
    //         onBlur={() => triggerControlVisibility(true)}
    //         onFocus={() => triggerControlVisibility(false)}
    //     />
    // );
};

export default Text;
